/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type DeactivateUserMutationInput = {
    clientMutationId?: string | null | undefined;
};
export type DeactivateUserMutationVariables = {
    input: DeactivateUserMutationInput;
};
export type DeactivateUserMutationResponse = {
    readonly deactivateUser: {
        readonly clientMutationId: string | null;
        readonly viewer: {
            readonly id: string;
            readonly user: {
                readonly id: string;
            } | null;
        } | null;
        readonly user: {
            readonly id: string;
        } | null;
    } | null;
};
export type DeactivateUserMutation = {
    readonly response: DeactivateUserMutationResponse;
    readonly variables: DeactivateUserMutationVariables;
};



/*
mutation DeactivateUserMutation(
  $input: DeactivateUserMutationInput!
) {
  deactivateUser(input: $input) {
    clientMutationId
    viewer {
      id
      user {
        id
      }
    }
    user {
      id
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        } as any
    ], v1 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v2 = {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
            (v1 /*: any*/)
        ],
        "storageKey": null
    } as any, v3 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "DeactivateUserMutationPayload",
            "kind": "LinkedField",
            "name": "deactivateUser",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "clientMutationId",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        (v1 /*: any*/),
                        (v2 /*: any*/)
                    ],
                    "storageKey": null
                },
                (v2 /*: any*/)
            ],
            "storageKey": null
        } as any
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "DeactivateUserMutation",
            "selections": (v3 /*: any*/),
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "DeactivateUserMutation",
            "selections": (v3 /*: any*/)
        },
        "params": {
            "cacheID": "13f38b172c39985324521a5ddf3f3bce",
            "id": null,
            "metadata": {},
            "name": "DeactivateUserMutation",
            "operationKind": "mutation",
            "text": "mutation DeactivateUserMutation(\n  $input: DeactivateUserMutationInput!\n) {\n  deactivateUser(input: $input) {\n    clientMutationId\n    viewer {\n      id\n      user {\n        id\n      }\n    }\n    user {\n      id\n    }\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = '9d2b5a3ae9d6402f8a73d83f3d42d795';
export default node;
